import { io } from "socket.io-client";

const socket = io("/", {
  transports: ["websocket", "polling"],
  withCredentials: true,
  autoConnect: false
});

export default socket;